import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { TRootState } from "../../store/reducers/RootReducer";
import { TOrdersByIdState } from "../../store/reducers/ordersById";
import { fetchOrderDetails, updateOrder } from "../../store/action-creators/orders";
import { Button } from "react-bootstrap";
import RealtimeProductConfigurator from "../../components/RealtimeProductConfigurator";
import { valuesToProduct } from "../../utils/ProductFormHelpers";
import { paths } from "../../router";
import { useHistory } from "react-router";
import { TApiSubset } from "../../api/endpoints/Subset";
import { TApiSubsetOptions } from "../../api/endpoints/SubsetOption";
import { IProductFormValues } from "../../components/RealtimeProductConfigurator/ProductForm";
import { FormikProps } from "formik";
import LoadingIndicator from "../../components/Feedback/LoadingIndicator";
import { OrderCategory, TApiOrderDetails } from "../../api/endpoints/Order";
import * as Api from "../../api";

interface IRouteParams {
  orderId: string;
}

const RealtimeOrderProductNew = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams<IRouteParams>();

  const orderState = useSelector<TRootState, TOrdersByIdState[string] | undefined>(store => store.ordersById[params.orderId])
  const order = orderState?.data;

  useEffect(() => {
    dispatch(fetchOrderDetails(params.orderId));
  }, [params.orderId])

  if (!order || orderState?.loading) {
    return <LoadingIndicator />;
  }

  if (order.category !== OrderCategory.REALTIME) {
    return <div>Page not found.</div>
  }

  const onSubmit = (
    subset: TApiSubset,
    subsetOptions: TApiSubsetOptions,
    formik: FormikProps<IProductFormValues>
  ) => () => {
    const newProductData = valuesToProduct(subset, subsetOptions, formik.values)

    formik.setSubmitting(true);

    formik.submitForm().then(() => {
      if (!formik.isValid) {
        return;
      }

      Api.OrderProduct.create(order.id, newProductData)
        .then(() => {
          formik.setSubmitting(false);
          formik.resetForm({ values: formik.values });

          history.push(paths.order(order.id));
        })
        .catch(() => {
          formik.setSubmitting(false);
        });
    })
  };

  return (
    <Fragment>
      <RealtimeProductConfigurator
        actions={
          (subset, subsetOptions, formik) => {
            return (
              <Button
                disabled={formik.isSubmitting}
                onClick={onSubmit(subset, subsetOptions, formik)}
              >
                {formik.isSubmitting ? 'Adding to order...' : 'Add to order'}
              </Button>
            )
          }
        }
      />
    </Fragment>
  )
}

export default RealtimeOrderProductNew;
